import React,{useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

function Login(props)
{
  let Cmp=props.Cmp
  const Navigate = useNavigate();
  useEffect(()=>{
    if(!localStorage.getItem('user-info')){
        Navigate("/Login");
    }
  },[])

  return(
    <div>
      <Cmp />
    </div>
  )
}

export default Login
